import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Loading } from '../../../../../../../common/loading'
import {
  getHighlightScore,
  selectLoadingHightLight,
  selectTypePeriod,
} from '../../../../store/slice'
import { getHighlight } from '../../../../store/thunk'
import { ItemHightLight } from './ItemHightLight'
import { ScoreFormat } from './ScoreFormat'
import classes from './index.module.scss'

export const HighLight = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const params = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const locale = useSelector((state) => state.i18n.locale)
  const timeFrequency = useSelector(selectTypePeriod)
  const isLoading = useSelector(selectLoadingHightLight)

  const { performanceScore, prevPerformanceScore, performanceScoreColor } =
    useSelector(getHighlightScore())

  useEffect(() => {
    dispatch(
      getHighlight({
        OrganizationId: params.organizationId,
        TimeFrequency: timeFrequency,
      }),
    )
  }, [locale, timeFrequency, params.organizationId])

  return (
    <div className="positionRelative">
      {isLoading && <Loading />}
      <div
        className={classes.hightLight}
        style={{ opacity: isLoading ? 0 : 1 }}
      >
        <ItemHightLight text="score.hightLight.CORPORATE_PERFORMANCE_SCORE">
          <ScoreFormat
            current={performanceScore}
            prev={prevPerformanceScore}
            scoreColor={performanceScoreColor}
          />
        </ItemHightLight>
      </div>
    </div>
  )
}
